import moment from 'moment-timezone';

export const AGENCY_TIMEZONE_COOKIE = 'agency-timezone';

const normalizeTimezone = (value) => {
  if (typeof value !== 'string') return null;
  const timezone = value.trim();
  return timezone && moment.tz.zone(timezone) ? timezone : null;
};

const normalizePrivileges = (privileges) => {
  if (Array.isArray(privileges)) return privileges;
  if (typeof privileges !== 'string' || privileges.trim() === '') return [];

  try {
    const parsed = JSON.parse(privileges);
    return Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    return [];
  }
};

/** Resolve an agency timezone from the selected agency privilege/document. */
export const findAgencyTimezone = (privileges, agencyUuid, agencyId) => {
  const selected = normalizePrivileges(privileges).find((privilege) => {
    const agency = privilege?.agency || privilege;
    return (agencyUuid && (agency?.oid === agencyUuid || agency?.agencyUUID === agencyUuid))
      || (agencyId && agency?.agencyId === agencyId);
  });
  const agency = selected?.agency || selected;

  return normalizeTimezone(
    agency?.timezone
      || agency?.agencyTz
      || selected?.timezone
      || selected?.agencyTimezone,
  );
};

/**
 * Agency data is authoritative. The dedicated cookie is only a persisted copy of
 * that value; user-profile and browser timezones must not determine agency reports.
 */
export const resolveAgencyTimezone = ({
  privileges,
  agencyUuid,
  agencyId,
  persistedTimezone,
} = {}) => (
  findAgencyTimezone(privileges, agencyUuid, agencyId)
    || normalizeTimezone(persistedTimezone)
    || null
);
